<div *transloco="let t; prefix: 'shared.request-walkthrough-modal'" class="flex flex-row justify-between">
  <h2 *ngIf="property" class="text-black text-[1.75rem]">
    {{ t("request-walkthrough-select-date.headers.requestWalkthroughFor") }}
    {{
    t("request-walkthrough-select-date.headers.propertyInfo", {
    propertyArea: property?.propertyArea,
    propertyType:
    "shared.enum.propertyType." + (property?.type ?? "Unknown")
    | transloco,
    prefecture: property?.address?.prefecture,
    })
    }}
  </h2>
  <button class="p-2">
    <i class="icon-close text-black text-xl" (click)="closeDialog()"></i>
  </button>
</div>
<div class="divider-line1 my-6"></div>

<div class="flex flex-col" *transloco="
    let t;
    prefix: 'shared.request-walkthrough-modal.request-walkthrough-select-date'
  ">
  <div class="flex flex-col gap-y-10" [formGroup]="form">
    <div class="flex flex-col gap-6">
      <h3>{{ t("headers.dayAndTimeslot") }}</h3>
      <date-picker [yearsOnly]="false" [inline]="true" [minDate]="now" (valueChange)="selectDate($event)"></date-picker>
      <div class="divider-line1"></div>
      <div class="flex flex-col gap-4 items-center">
        <div class="flex flex-row gap-6 w-full justify-center">
          <div class="flex flex-col flex-1 w-full">
            <label>{{ t("labels.from") }}</label>
            <app-timepicker [form]="form" controlName="from" [selectedDate]="selectedDate"></app-timepicker>
          </div>
          <div class="flex flex-col flex-1 w-full">
            <label>{{ t("labels.to") }}</label>
            <app-timepicker [form]="form" controlName="to" [selectedDate]="selectedDate"></app-timepicker>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="pt-4 flex gap-4">-->
    <!--  <label for="checkbox-selector-" class="checkbox-selector">-->
    <!--    <input-->
    <!--      type="checkbox"-->
    <!--      class="hidden"-->
    <!--      id="checkbox-selector-"-->
    <!--      [checked]="form.controls.acceptedTerms.value == true"-->
    <!--      (click)="updateTerms()"-->
    <!--    />-->
    <!--    <div class="ml-2 checkbox-selector-content">-->
    <!--      <span class="checkbox-selector-text">{{ t("consent-terms") }}</span>-->
    <!--    </div>-->
    <!--  </label>-->
    <!--</div>-->
    <div class="flex flex-col items-center">
      <button class="btn-primary w-fit disabled:border-gray-200" [disabled]="form.invalid" (click)="next()">
        {{ t("buttons.next") }}
      </button>
    </div>
  </div>
</div>

<style scoped>
  .timepicker {
    border: 1px solid;
    padding: 0 0.5rem;
  }
</style>
